<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "MYQUOTES.MYQUOTES" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="h1 pr-16">Cotizaciones</div>
                    <button
                        mat-icon-button
                        color="accent"
                        (click)="mostrarFiltros = !mostrarFiltros"
                    >
                        <mat-icon color="secondary">filter_list</mat-icon>
                    </button>
                </div>

                <app-filtro-cotizacion
                    *ngIf="clientes && vigencias && situaciones"
                    [clientes]="clientes"
                    [situaciones]="situaciones"
                    [vigencias]="vigencias"
                    [hidden]="!mostrarFiltros"
                    [setearFiltros]="setearFiltros"
                    (filtrarCotizaciones)="filtrar($event)"
                ></app-filtro-cotizacion>
                <app-tabla-cotizaciones
                    *ngIf="cotizaciones"
                    [cotizaciones]="cotizaciones"
                    (solicitarActualizacionEvent)="
                        solicitarActualizacion($event)
                    "
                    (actualizarVigenciaEvent)="actualizarVigencia($event)"
                    [procesando]="procesando"
                    [total]="total"
                    (buscarMas)="buscarCotizaciones($event)"
                ></app-tabla-cotizaciones>
            </div>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
